module.exports = __webpack_public_path__ + "img/75.0d874e1c.png";